'use client';

import { padZero } from '@/utils';

import { useCountdownTimer } from './useCountdownTimer';

type CountdownTimerProps = {
  targetDate: Date;
  label?: string;
  expiredTitle?: string;
  expiredSubtext?: string;
} & React.HTMLAttributes<HTMLDivElement>;

export const CountdownTimer = ({
  targetDate,
  className,
  label,
  expiredTitle,
  expiredSubtext = 'SORTEIO REALIZADO',
}: CountdownTimerProps) => {
  const { days, hours, minutes, seconds, isExpired, showDays } =
    useCountdownTimer(targetDate);

  if (isExpired) {
    return (
      <div
        className={`flex flex-col items-center justify-center text-secondary rounded-lg font-semibold text-sm ${className ?? ''}`}
      >
        {expiredTitle && <span className="uppercase text-center">{expiredTitle}</span>}
        <span className="uppercase text-center">{expiredSubtext}</span>
      </div>
    );
  }

  const countdown = (
    <div className="flex flex-row items-center space-x-1">
      {showDays && (
        <span className="text-secondary font-bold text-xl leading-none">
          {padZero(days)}d
        </span>
      )}
      <span className="text-secondary font-bold text-xl leading-none">
        {padZero(hours)}h
      </span>
      <span className="text-secondary font-bold text-xl leading-none">
        {padZero(minutes)}m
      </span>
      <span className="text-secondary font-bold text-xl leading-none">
        {padZero(seconds)}s
      </span>
    </div>
  );

  if (label) {
    return (
      <div className={`flex flex-col items-center justify-start ${className ?? ''}`}>
        <span className="uppercase text-center font-semibold text-sm">{label}</span>
        {countdown}
      </div>
    );
  }

  return countdown;
};
